export default function AuthTemplate({ children }) {
  return (
    <div className="flex flex-1 justify-center">
      <div className="flex flex-1 justify-center items-center bg-secondary">{children}</div>
    </div>
  );
}
